import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../axios/AxiosInstance";
import { connectClients } from "../commercial/services/liveClients";
import {
  userDailyState,
  periodIndicators,
} from "../commercial/services/daily.mjs";
import { reportingPeriod, todayParis } from "../commercial/utils/calendar.mjs";
import {
  dashboardMetrics,
  shiftDate,
} from "../commercial/dashboard-metrics.mjs";
import {
  WeeklyIndicators,
  CommercialPipeline,
  DailyCard,
} from "../commercial/components/daily/DailyWidgets";
import ClientDetail from "../pages/ClientDetail";
import "../commercial/style.css";
export default function DashboardCommercialSummary() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [clients, setClients] = useState([]);
  const [error, setError] = useState("");
  const [selection, setSelection] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const userId = localStorage.getItem("userId");
  const key = `jm-commercial-live:${userId}:${localStorage.getItem("agencyName")}`;
  useEffect(() => {
    let active = true;
    axios
      .get("client/freelance")
      .then(({ data: list }) => {
        if (!active) return;
        const clients = Array.isArray(list) ? list : [];
        let saved = null;
        try {
          saved = JSON.parse(localStorage.getItem(key));
        } catch {}
        const user = {
          id: userId,
          name: [
            localStorage.getItem("firstname"),
            localStorage.getItem("lastname"),
          ]
            .filter(Boolean)
            .join(" "),
          role: "commercial",
          agency:
            localStorage.getItem("agencyCity") ||
            localStorage.getItem("agencyName") ||
            "Mon agence",
        };
        setClients(clients);
        setData(userDailyState(connectClients(clients, user, saved), userId));
      })
      .catch(() => {
        if (active)
          setError("Impossible de charger les indicateurs commerciaux.");
      });
    return () => {
      active = false;
    };
  }, [key, userId]);
  if (error)
    return (
      <p role="alert" className="mb-6 text-sm text-rose-700">
        {error}
      </p>
    );
  if (!data)
    return (
      <p role="status" className="mb-6 text-sm text-slate-500">
        Chargement des indicateurs commerciaux…
      </p>
    );
  const today = todayParis();
  const week = reportingPeriod("week", today);
  const actual = periodIndicators(data, week.from, week.to);
  const previous = periodIndicators(
    data,
    shiftDate(week.from, -7),
    shiftDate(week.to, -7),
  );
  return (
    <div className="commercial-module mb-6">
      <div
        className="dailyLowerGrid"
        style={{
          gridTemplateColumns:
            "repeat(auto-fit, minmax(min(100%, 360px), 1fr))",
          alignItems: "start",
        }}
      >
        <WeeklyIndicators actual={actual} previous={previous} />
        <CommercialPipeline
          state={data}
          stages={dashboardMetrics(data, today).stages}
          onSelect={setSelection}
        />
      </div>
      {selection && (
        <DailyCard
          title={selection.title}
          action={
            <button className="textAction" onClick={() => setSelection(null)}>
              Fermer
            </button>
          }
        >
          {selection.items.map((item) => (
            <button
              key={item.id}
              className="dailyOpportunity"
              onClick={() => {
                if (selection.kind === "clients") {
                  const client = clients.find(
                    (client) =>
                      client._id === (item.establishment_id || item.id),
                  );
                  if (client) setSelectedClient(client);
                  else navigate("/actions-commerciales");
                } else navigate("/commandesPage");
              }}
            >
              <b>
                {selection.kind === "clients"
                  ? item.name
                  : data.clients.find((client) => client.id === item.clientId)
                      ?.name}
              </b>
              <small>{item.job || item.title || item.status}</small>
            </button>
          ))}
          {!selection.items.length && (
            <p className="dashboardEmpty">
              Aucun élément pour cette sélection.
            </p>
          )}
        </DailyCard>
      )}
      {selectedClient && (
        <ClientDetail
          key={selectedClient._id}
          client={selectedClient}
          setClient={setSelectedClient}
          clients={clients}
          setClients={setClients}
          originalClients={clients}
        />
      )}
    </div>
  );
}
